import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_16_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-16-01",
    "name": "腿部热身",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["下肢动态热身", "关节活动+肌肉激活"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/45d0e35d5babf9b1bd3f11c2.mp4",
    "videoUrl": "/media/collections-20261008/videos/8f431c55b9eaa3a574507b87.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第16期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-16-02",
    "name": "保加利亚蹲",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "quads-glutes",
    "tips": ["腿部主导版本", "股四头侧重"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "demoUrl": "/media/collections-20261008/demos/reviewed-6553212d04bc1f58fe959574.mp4",
    "videoUrl": "/media/collections-20261008/videos/reviewed-607e975fde3077cdf0077372.mp4",
    "targetMuscles": ["股四头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第16期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-16-03",
    "name": "俯身腿弯举",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "hamstrings",
    "tips": ["臀部贴紧凳面", "感受腘绳肌收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-1d51cb0a5c2277b5c3748e19.mp4",
    "videoUrl": "/media/collections-20261008/videos/4556a122f358991b8f7eacdc.mp4",
    "targetMuscles": ["腘绳肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第16期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-16-04",
    "name": "坐姿腿屈伸",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "quadriceps",
    "tips": ["坐姿腿屈伸", "股四头孤立"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/60793a3aaccfadbf76966a23.mp4",
    "videoUrl": "/media/collections-20261008/videos/49182e82548e3865fc39f434.mp4",
    "targetMuscles": ["股四头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第16期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-16-05",
    "name": "犀牛蹲",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "quadriceps",
    "tips": ["按新视频使用犀牛蹲器械及腰带负重", "控制下蹲与起身节奏"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-291bb6830d3077d7d52e5adc.mp4",
    "videoUrl": "/media/collections-20261008/videos/5a28003bbe3dffd78855ecd4.mp4",
    "targetMuscles": ["股四头肌", "臀大肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第16期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
